import PropTypes from 'prop-types';
import React from 'react';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { withRouteData } from 'react-static';
import { get } from 'lodash';

export const renderFree = () => {
  return (
    <FormattedMessage
      id="livestream-event.concert.free-of-charge"
      defaultMessage="Free of charge"
    />
  );
};

export const renderFixedPrice = (values, currency) => {
  const value = values[currency];
  if (!value) {
    return null;
  }

  return <FormattedNumber currency={currency} style="currency" value={value} />;
};

const renderVariablePrice = (minValues, maxValues, currency) => {
  const minValue = get(minValues, currency);
  const maxValue = get(maxValues, currency);
  if (!minValue || !maxValue) {
    return null;
  }

  const minPrice = <FormattedNumber style="currency" currency={currency} value={minValue} />;

  const maxPrice = <FormattedNumber style="currency" currency={currency} value={maxValue} />;

  return (
    <FormattedMessage
      id="livestream-event.concert.variable-price"
      defaultMessage="{minPrice} - {maxPrice}"
      values={{
        minPrice,
        maxPrice,
      }}
    />
  );
};

const Price = ({ event, currency }) => {
  const { isFree, isFixed, fixedValues, variableValues } = event;

  if (isFree) {
    return renderFree();
  }

  if (isFixed) {
    return renderFixedPrice(fixedValues, currency);
  }

  return renderVariablePrice(get(variableValues, 'min'), get(variableValues, 'max'), currency);
};

Price.defaultProps = {
  currency: 'EUR',
};

Price.propTypes = {
  currency: PropTypes.string.isRequired,
  event: PropTypes.object.isRequired,
};

export default withRouteData(Price);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/livestreamEvent/PriceTemplate.js